import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import { TruncateNum } from '../../Components/truncateNumber';
import { GetOrder, CancelOrderItem, GetOrderDetails, RegisterPayment, checkSession } from './module';

const initialState = {
    orderDetails: null,
    invoiceDetails: null,
    invoiceList: [],
    orderDetailsList: [],
    tenantList: null,
    mySession: null,
    invoices: {
        getInvItemsId: [],
        displayInvoiceItem: [],
        totalAmount: 0,
        disabledIfNoSelectInvoice: true
    },
    orderCodes2: null,
    payCount: 0,
    status: "idle",
    ActionStatus: "",
    errorMessage: "",
    paymentloading: false,
};

export const GetOrderAsync = createAsyncThunk(
    'invoices/GetOrder',
    async (data, ThunkAPI) => {
        const response = await GetOrder({...data, AttachmentChecking: false});
        const resultPromise = Promise.resolve(response);
        resultPromise.then(() => {
            setTimeout(() => {
                ThunkAPI.dispatch(GetOrderDetailsAsync({ ...data, AttachmentChecking: false }));
            }, 1000);

        })
        return response;
    }
);

export const checkSessionAsync = createAsyncThunk(
    'invoices/checkSession',
    async (index, ThunkAPI) => {
        const response = await checkSession();
        return response;
    }
);

export const GetOrderDetailsAsync = createAsyncThunk(
    'invoices/GetOrderDetails',
    async (data, ThunkAPI) => {
        const response = await GetOrderDetails(data);
        return response;
    }
);

export const RegisterPaymentAsync = createAsyncThunk(
    'invoices/RegisterPayment',
    async (data, ThunkAPI) => {
        const response = await RegisterPayment(data);

        return response;
    }
);

export const CancelOrderItemAsync = createAsyncThunk(
    'invoices/CancelOrderItem',
    async (data, ThunkAPI) => {
        const response = await CancelOrderItem(data[1]);
        const resultPromise = Promise.resolve(response);
        resultPromise.then(() => {
            ThunkAPI.dispatch(GetOrderAsync(data[0]));
        })
        return response;
    }
);

export const invoicesSlice = createSlice({
    name: 'invoices',
    initialState,
    reducers: {
        saveSelectedInvoices: (state, action) => {
            var invoices = {
                getInvItemsId: action.payload.getInvItemsId,
                displayInvoiceItem: action.payload.displayInvoiceItem,
                totalAmount: action.payload.totalAmount,
                disabledIfNoSelectInvoice: action.payload.disabledIfNoSelectInvoice,
            }
            state.invoices = invoices;
        },
        initiateAction: (state, action) => {
            state.paymentloading = false;
            state.invoices = {
                getInvItemsId: [],
                displayInvoiceItem: [],
                totalAmount: 0,
                disabledIfNoSelectInvoice: true,
            }
        },

    },
    extraReducers: (builder) => {
        builder.addCase(GetOrderAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetOrderAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetOrderAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            try {
                state.orderDetails = action.payload ? action.payload.Orders ? action.payload.Orders[0] : null : null;
                state.payCount = (state.orderDetails.Invoices.filter((data) => data.StatusCode === 'PP').map.length);
                var invoiceList = [];
                if (state.orderDetails.Invoices && state.orderDetails.Invoices.length > 0) {
                    state.orderDetails.Invoices.forEach((item) => {
                        if (item.QuoteIds && item.QuoteIds.length > 0) {
                            item.QuoteIds.forEach((quote) => {
                                invoiceList.push(quote);
                            })
                        }
                    })
                }

                state.invoiceList = invoiceList;
                state.orderDetailsList = [];
                if (action.payload && action.payload.Status !== 'OK') {
                    alert(action.payload.ErrorMessage)
                }
            } catch (error) {
                console.log("error at ionvoice GetOrderAsync", error)
            }
        });
        builder.addCase(GetOrderDetailsAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(GetOrderDetailsAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(GetOrderDetailsAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            try {
                state.invoiceDetails = action.payload;
                //var invoiceList = current(state.invoiceList);
                var orderDetails = current(state.orderDetails);
                //var invoicesDetailsList = action.payload ? action.payload.Orders : [];
                // var invoicesDetailsList = action.payload ? action.payload.Orders.filter((data) => invoiceList.includes(data.QuoteId)) : [];
                var invoicesDetailsList = action.payload ? action.payload.Orders : [];

                if (orderDetails && orderDetails.Invoices && orderDetails.Invoices.length > 0) {
                    orderDetails.Invoices.forEach((inv) => {
                        inv.QuoteIds.forEach((Invquote) => {
                            invoicesDetailsList.forEach((quote, index) => {
                                if (quote.QuoteId === Invquote) {
                                    var orderItems = [];
                                    var bundlePrices = [];
                                    var itemPrices = [];
                                    var groupPrices = [];
                                    var gst = 0;
                                    var totalAmount = 0;

                                    quote.Items.forEach(function (item) {
                                        if (item.QuoteType === 'Bundle' || !item.ItemGroupId) {
                                            orderItems = orderItems.concat(item.OrderItems);
                                            state.orderCodes2 = item.OrderItems[0].OrderCode;
                                        }

                                        var orderItemName = [];
                                        var orderItemAANo = [];
                                        var orderCodes = [];

                                        item.OrderItems.forEach(function (orderItem) {
                                            orderItemAANo.push(orderItem.SourceNo);
                                            orderItemName.push(orderItem.SourceTitle);
                                            orderCodes.push(orderItem.ItemCode);
                                        });

                                        if (item.ItemGroupId) {
                                            groupPrices.push({
                                                description: item.PriceRuleDescription,
                                                orderCodes: orderCodes,
                                                orderItemAANo: orderItemAANo,
                                                // amount: parseFloat(item.ActualItemAmount).toFixed(2),
                                                amount: !(isNaN(item.ActualItemAmount) && isNaN(parseFloat(item.ActualItemAmount))) ? parseFloat(item.ActualItemAmount) : 0,
                                            });
                                        }

                                        if (item.ItemBundleId) {
                                            bundlePrices.push({
                                                description: item.PriceRuleDescription,
                                                orderItemName: orderItemName,
                                                amount: !(isNaN(item.ActualItemAmount) && isNaN(parseFloat(item.ActualItemAmount))) ? parseFloat(item.ActualItemAmount) : 0,

                                                // amount: parseFloat(item.ActualItemAmount).toFixed(2),
                                            });
                                        }

                                        if (!item.ItemBundleId && !item.ItemGroupId) {
                                            itemPrices.push({
                                                description: item.PriceRuleDescription,
                                                orderItemName: orderItemName,
                                                // amount: parseFloat(item.ActualItemAmount).toFixed(2),
                                                amount: !(isNaN(item.ActualItemAmount) && isNaN(parseFloat(item.ActualItemAmount))) ? parseFloat(item.ActualItemAmount) : 0,
                                            });
                                        }

                                        gst += (isNaN(item.ActualItemGSTAmount) && isNaN(parseFloat(item.ActualItemGSTAmount))) ? 0 : parseFloat(item.ActualItemGSTAmount);
                                        totalAmount += (isNaN(item.ItemTotalAmount) && isNaN(parseFloat(item.ItemTotalAmount))) ? 0 : parseFloat(item.ItemTotalAmount);
                                    });

                                    var dataItems = {
                                        invoiceId: inv.InvoiceId,
                                        invoiceCode: inv.InvoiceCode,
                                        invoiceIsExpired: inv.IsExpired,
                                        StatusCode: inv.StatusCode,
                                        invDueDate: inv.DueDate,
                                        IsPaid: inv.IsPaid,
                                        //orderCode: $scope.orderCodes2,
                                        quoteId: quote.QuoteId,
                                        quoteCode: quote.QuoteCode,
                                        orderItems: orderItems,
                                        bundlePrices: bundlePrices,
                                        itemPrices: itemPrices,
                                        groupPrices: groupPrices,
                                        gst: parseFloat(parseFloat(gst).toFixed(2)),
                                        totalAmount: totalAmount
                                    }

                                    state.orderDetailsList.push(dataItems);
                                }
                            });
                        })
                    })
                }


                if (action.payload && action.payload.Status !== 'OK') {
                    alert(action.payload.ErrorMessage)
                }
            } catch (error) {
                console.log("error at ionvoice GetOrderDetailsAsync", error)
            }

        });

        builder.addCase(CancelOrderItemAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(CancelOrderItemAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(CancelOrderItemAsync.fulfilled, (state, action) => {
            state.status = 'idle';
            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            }
        });
        builder.addCase(RegisterPaymentAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(RegisterPaymentAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(RegisterPaymentAsync.fulfilled, (state, action) => {
            state.status = 'idle';

            if (action.payload && action.payload.Status !== 'OK') {
                alert(action.payload.ErrorMessage)
            } else {
                state.paymentloading = true;
                var payment = action.payload;
                var form = document.createElement("form");
                var paymentElement = document.createElement("input");

                form.method = "POST";
                form.action = payment.Url;

                paymentElement.value = payment.PaymentXml;
                paymentElement.type = "hidden";
                paymentElement.name = "PAYMENT";

                form.appendChild(paymentElement);

                document.body.appendChild(form);

                form.submit();
            }

        });
        builder.addCase(checkSessionAsync.pending, (state) => {
            state.status = 'loading';
        });
        builder.addCase(checkSessionAsync.rejected, (state) => {
            state.status = 'rejected';
        });
        builder.addCase(checkSessionAsync.fulfilled, (state, action) => {
            state.status = 'idle';

            if (action.payload && action.payload.Status !== 'OK') {
                window.location.href = "./login";
            }
        });
    }
});

export const { saveSelectedInvoices, initiateAction } = invoicesSlice.actions;
export const pageDetails = (state) => state.paymentDetails.orderDetails;
export const invoiceDetails = (state) => state.paymentDetails.invoices;
export const orderDetailsList = (state) => state.paymentDetails.orderDetailsList;
export const pagesState = (state) => state.paymentDetails;
export const paymentloading = (state) => state.paymentDetails.paymentloading;
export const mySession = (state) => state.Session.mySession;

export default invoicesSlice.reducer;
